<template>
  <el-dropdown>
    <i
      class="iconfont icon-gengduo pointer three-point"
    ></i>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
      >
        <div class="btn-text" @click="transferHandle">{{$t('User.transferAccounts')}}</div>
      </el-dropdown-item>
      <el-dropdown-item
      >
        <div class="btn-text" @click="leverHandle">{{$t('User.leverSet')}}</div>
      </el-dropdown-item>
      <el-dropdown-item
      >
        <div class="btn-text" @click="passwordHandle">{{$t('User.passSet')}}</div>
      </el-dropdown-item>
      <el-dropdown-item
      >
        <div class="btn-text"
             @click="copySetHandle"
        >{{$t('Copy_settings')}}</div>
      </el-dropdown-item>
      <el-dropdown-item
      >
        <div class="btn-text"
             @click="detailHandle"
        >{{$t('copyMaster.view_the_details')}}</div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "accountOperate",
  props: {
  },
  methods: {
    transferHandle() {
      this.$emit('transferHandle');
    },
    leverHandle(){
      this.$emit('leverHandle');
    },
    passwordHandle(){
      this.$emit('passwordHandle');
    },
    copySetHandle(){
      this.$emit('copySetHandle')
    },
    detailHandle(){
      this.$emit('detailHandle')
    },
  },
}
</script>

<style lang="scss" scoped>
.three-point {
  font-size: 16px;
  padding: 10px;
  padding-right: 5px;
}

</style>
